import { Localized } from 'dg-web-shared/lib/Localization';
import {
    PaymentMethodForm,
    PaymentMethodType,
} from '../../../components/forms/PaymentMethodForm';
import { Outlet } from 'react-router';
import { ParkingaboLayoutWithHeader } from '../../../components/layout/ParkingaboLayoutWithHeader';
import { useParkingaboAuthedPathGeneration } from '../../RouteUtils';
import { ParkingaboFooter } from '../../../components/layout/ParkingaboFooter.tsx';
import { useCustomerContext } from '../../../components/CustomerProvider.tsx';

export function AddPaymentMethodRoute({
    paymentMethodType,
}: {
    paymentMethodType: PaymentMethodType;
}) {
    const {
        user: { operatorExternalId },
    } = useCustomerContext();
    const generateAuthedParkingaboPath = useParkingaboAuthedPathGeneration();
    return (
        <ParkingaboLayoutWithHeader
            title={
                <Localized
                    de="Zahlungsmittel"
                    fr="Moyen de paiement"
                    it="Mezzo di pagamento"
                    en="Payment mean"
                />
            }
            backTo={generateAuthedParkingaboPath('')}
            noGutter
        >
            <Outlet />

            <PaymentMethodForm paymentMethodType={paymentMethodType} />

            <ParkingaboFooter operatorExternalId={operatorExternalId} />
        </ParkingaboLayoutWithHeader>
    );
}
